import React, { useCallback } from "react";
import { IDetailedProject } from "../../pages/Project";
import ApprovalModal from "./ApproveModal";
import AssignModal from "./AssignModal";
import CancelModal from "./CancelModal";
import DisapprovalModal from "./DisapproveModal";
import EstimateModal from "./EstimateModal";
import SendProposalModal from "./SendProposalModal";
import { ActionsContainer } from "./styles";
import SuspendModal from "./SuspendModal";
import ProposalModal, { IActivity } from "./ProposalModal";
import ConcludeProject from "./ConcludeProject";

export interface IProposal {
  deadline_payment: string;
  number_installments: string;
  percent?: string;
  project_id: string;
  status?: string;
  implantation?: number;
  proposal_approval?: number;
  delivery_homologation?: number;
  value_hours: number;
  value_installments: number;
  type: string;
  value_project: number;
  number_proposal: string;
  activityToHoursAllocation?: {
    actvity_id: string;
    configsHour: { id: string };
  }[];
  activity: IActivity;
}

interface IProjectActionsProps {
  project?: IDetailedProject;
  handleUpdateProject: (project: IDetailedProject) => void;
  proposal?: IProposal;
}

// objeto com arry de ações ou components para cada status

export interface IActionModalProps {
  project: IDetailedProject;
  handleUpdateProject: (project: IDetailedProject) => void;
  proposal?: IProposal;
}

interface IActionType {
  [key: string]: {
    Component: React.FC<IActionModalProps>;
  }[];
}

const actions: IActionType = {
  UNDERSTANDING: [
    { Component: EstimateModal },
    { Component: ConcludeProject },
    { Component: CancelModal },
    { Component: SuspendModal },
  ],
  PROPOSAL_SENDING: [
    { Component: ProposalModal },
    { Component: SendProposalModal },
    { Component: ConcludeProject },
    { Component: CancelModal },
    { Component: SuspendModal },
  ],
  WAITING_APPROVAL: [
    { Component: ProposalModal },
    { Component: ApprovalModal },
    { Component: ConcludeProject },
    { Component: DisapprovalModal },
    { Component: CancelModal },
    { Component: SuspendModal },
  ],
  APPROVED: [
    { Component: ProposalModal },
    { Component: AssignModal },
    { Component: ConcludeProject },
    { Component: CancelModal },
    { Component: SuspendModal },
  ],
  DISAPPROVED: [],
  ASSIGNING: [
    { Component: ProposalModal },
    { Component: AssignModal },
    { Component: ConcludeProject },
    { Component: CancelModal },
    { Component: SuspendModal },
  ],
  CANCELED: [],
  SUSPENDED: [],
  WAITING_DEVELOPMENT: [
    { Component: ProposalModal },
    { Component: ConcludeProject },
    { Component: CancelModal },
    { Component: SuspendModal },
  ],
  DEVELOPMENT: [
    { Component: ProposalModal },
    { Component: ConcludeProject },
    { Component: CancelModal },
    { Component: SuspendModal },
  ],
  CONCLUDED: [],
};

const ProjectActions: React.FC<IProjectActionsProps> = ({
  project,
  proposal,
  handleUpdateProject,
}) => {
  const Actions = useCallback(() => {
    return project ? (
      <ActionsContainer>
        {actions[project?.status].map(({ Component }) => (
          <Component
            project={project}
            proposal={proposal}
            handleUpdateProject={handleUpdateProject}
          />
        ))}
      </ActionsContainer>
    ) : (
      <></>
    );
  }, [handleUpdateProject, project]);

  return <Actions />;
};

export default ProjectActions;
